import { Button, FormLabel, Heading, Input, InputGroup, InputLeftAddon } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useForm } from '@tanstack/react-form'
import { Textarea, FormControl } from '@chakra-ui/react'
import { Manufacturer } from "../../models/manufacturer";
import { Sandbox } from "../../models/sandbox";
import { useFetch } from "../../contexts/FetchContext";
import { useFormKeyBindings } from "../../components/Helpers/useFormKeyBindings";
import { FormModal } from "../../components/Helpers/FormModal";

export const EditSandbox = () => {
    const [isLoading, setLoading] = useState<boolean>(true);
    const [manufacturer, setManufacturer] = useState<Manufacturer>();
    const [sandbox, setSandbox] = useState<Sandbox>();

    const { id } = useParams();
    const navigate = useNavigate();
    const { backend } = useFetch();

    const refetch = () => {
        if (id) {
            setLoading(true)
            backend.sandboxes.getById(parseInt(id))
                .then((sandbox) => {
                    setSandbox(sandbox)
                    setLoading(false)
                }).catch((error) => {
                    console.log(error)
                });
            backend.manufacturers.get()
                .then((data) => {
                    /* Må FIKSES */
                    const sandBoxManufacturer = data.find(manufacturer => manufacturer.name === "Sandbox")
                    if (sandBoxManufacturer) {
                        setManufacturer(sandBoxManufacturer)
                    } else {
                        onClose()
                    }
                    setLoading(false)
                });
        }
    }

    useEffect(() => {
        refetch()
    }, []);

    const onClose = () => {
        navigate(-1);
    };

    const form = useForm({
        defaultValues: {
            name: sandbox?.name || '',
            description: sandbox?.description || '',
            alias: sandbox?.alias || '',
            mail: sandbox?.mail || '',
        },
        onSubmit: async (values) => {
            if (await form.validateAllFields("submit")) {
                const updated_sandbox: Sandbox = {
                    description: values.description,
                    rentStatus: null,
                    id: sandbox!.id,
                    name: values.name,
                    alias: values.alias,
                    mail: values.mail,
                    deleted: sandbox!.deleted,
                    rentHistory: [],
                }
                backend.sandboxes.update(
                    updated_sandbox
                ).then((response) => {
                    onClose();
                }).catch((error) => {
                    console.log(error)
                });
            }
        }
    })

    useFormKeyBindings({
        handleSubmit: form.handleSubmit,
        handleClose: onClose,
        canSubmit: form.state.canSubmit,
        isSubmitting: form.state.isSubmitting
    });


    const FormFields = [
        (
            <form.Field
                name="name"
                children={field => {
                    return (
                        <FormControl isInvalid={field.state.meta.errors.length > 0}>
                            <FormLabel>Name</FormLabel>
                            <Input
                                autoFocus
                                variant='filled'
                                required
                                name={field.name}
                                value={field.state.value}
                                onBlur={field.handleBlur}
                                onChange={(e) => field.handleChange(e.target.value)}
                                placeholder="Name"
                            />
                        </FormControl>
                    )
                }}
            />
        ),
        (
            <form.Field
                name="alias"
                children={field => {
                    return (
                        <FormControl>
                            <FormLabel>Alias</FormLabel>
                            <Input
                                variant='filled'
                                required
                                name={field.name}
                                value={field.state.value}
                                onBlur={field.handleBlur}
                                onChange={(e) => field.handleChange(e.target.value)}
                                placeholder="Alias"
                            />
                        </FormControl>
                    )
                }}
            />
        ),
        (
            <form.Field
                name="mail"
                children={field => {
                    return (
                        <FormControl>
                            <FormLabel>Mail</FormLabel>
                            <Input
                                variant='filled'
                                type="email"
                                required
                                name={field.name}
                                value={field.state.value}
                                onBlur={field.handleBlur}
                                onChange={(e) => field.handleChange(e.target.value)}
                                placeholder='Mail'
                            />
                        </FormControl>
                    )
                }}
            />
        ), (
            <form.Field
                name="description"
                children={field => {
                    return (
                        <FormControl>
                            <FormLabel>Desciption</FormLabel>
                            <Textarea name="description" value={field.state.value} onChange={(e) => field.handleChange(e.target.value)}></Textarea>
                        </FormControl>
                    )
                }}
            />
        )
    ]

    const SubmitButton = () => {
        return (
            <Button colorScheme='blue' isLoading={form.state.isSubmitting} type="submit" disabled={!form.state.canSubmit}>
                Update
            </Button>
        )
    }

    const Header = () => {
        return (
            <>
                <Heading size='xl' mt={5}>New Sandbox</Heading>
            </>
        )
    }

    return (
        <FormModal
            isLoading={manufacturer && sandbox ? true : false}
            headerElements={[<Header />]}
            form={form}
            formFields={FormFields}
            SubmitButton={<SubmitButton />}
            onClose={onClose}
        />
    )
}
